<template>
  <md-card>
    <md-button
      class="md-just-icon md-round modal-default-button md-simple"
      @click="closePaper"
    >
      <md-icon>clear</md-icon>
    </md-button>
    <md-card-header class="md-card-header-icon md-card-header-brand">
      <div class="card-icon">
        <md-icon>file_copy</md-icon>
      </div>
      <h4>Papir</h4>
    </md-card-header>
    <md-card-content class="md-layout">
      <md-field class="md-layout-item md-size-20">
        <label> Naziv </label>
        <md-input type="text" v-model="paper.name"> </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Vrsta </label>
        <md-select v-model="paper.paperGroupId">
          <md-option
            v-for="(option, index) in paperGroups"
            :key="index"
            :value="option.id"
            >{{ option.name }}</md-option
          >
        </md-select>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Format </label>
        <md-select v-model="paper.formatId">
          <md-option
            v-for="(option, index) in formats"
            :key="index"
            :value="option.id"
            >{{ option.name }}</md-option
          >
        </md-select>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Grama po metru </label>
        <md-input type="number" v-model="paper.weight" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Debljina mm </label>
        <md-input
          type="number"
          v-model="paper.thickness"
          min="0.001"
          step="0.001"
        >
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Spora štampa % </label>
        <md-input type="number" v-model="paper.slowPrint" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Normalna štampa % </label>
        <md-input type="number" v-model="paper.normalPrint" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Brza štampa % </label>
        <md-input type="number" v-model="paper.fastPrint" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Savijanje 1/2 </label>
        <md-input type="number" v-model="paper.foldingHalf" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Savijanje 1/4 </label>
        <md-input type="number" v-model="paper.foldingQuarter" min="1" step="1">
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <md-checkbox v-model="paper.isForPackaging"> Za pakovanje </md-checkbox>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <md-checkbox v-model="paper.cardboard"> Lepenka </md-checkbox>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <md-checkbox v-model="paper.forDigitalPrint">
          Za digitalnu
        </md-checkbox>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Kupovna cijena € / kom </label>
        <md-input
          type="number"
          v-model="paper.buyingPrice"
          min="0.01"
          step="0.01"
        >
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-20">
        <label> Prodajna cijena € / kom </label>
        <md-input
          type="number"
          v-model="paper.sellingPrice"
          min="0.01"
          step="0.01"
        >
        </md-input>
      </md-field>
      <md-field class="md-layout-item md-size-100">
        <label>Komentar</label>
        <md-textarea v-model="paper.comment"> </md-textarea>
      </md-field>
    </md-card-content>
    <md-card-actions md-alignment="right">
      <md-button class="md-success" @click="setPaper">
        <md-icon> save </md-icon>
        Sačuvaj
      </md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';

export default {
  props: {
    id: Number,
    shouldCopyPaper: Boolean,
  },
  data() {
    return {
      paper: {
        name: null,
        paperGroupId: null,
        formatId: null,
        weight: null,
        thickness: null,
        slowPrint: null,
        normalPrint: null,
        fastPrint: null,
        foldingHalf: null,
        foldingQuarter: null,
        isForPackaging: null,
        cardboard: null,
        forDigitalPrint: null,
        buyingPrice: null,
        sellingPrice: null,
        comment: null,
      },
      paperGroups: [],
      formats: [],
    };
  },
  methods: {
    getPaperGroups() {
      return api
        .get(services.getPaperGroups, { getPaperGroups: true })
        .then((data) => {
          this.paperGroups = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getPaperFormats() {
      return api
        .get(services.getPaperFormats, { getPaperFormats: true })
        .then((data) => {
          this.formats = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    getPaper() {
      if (this.id)
        api
          .get(services.itemCount.getPaper, { getPaper: true, id: this.id })
          .then((data) => {
            this.paper = data;
          })
          .catch((error) => {
            this.alertError(error);
          });
    },
    setPaper() {
      const paper = this.paper;
      if (!this.shouldCopyPaper) paper.id = this.id;
      api
        .post(services.itemCount.setPaper, {
          setPaper: true,
          paper: JSON.stringify(paper),
        })
        .then((data) => {
          this.$emit('saved', data.id);
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    closePaper() {
      this.$emit('close');
    },
  },
  mounted() {
    this.getPaperGroups()
      .then(() => this.getPaperFormats())
      .then(() => this.getPaper());
  },
  watch: {
    id(to) {
      if (to) {
        this.getPaper();
      }
    },
  },
};
</script>
